import { Spinner, SpinnerProps } from '@chakra-ui/react';
import React from 'react';
import { DataProps } from '../../utils';

export type QSpinnerProps = SpinnerProps & DataProps;

export const QSpinner: React.FC<QSpinnerProps> = (props) => {
  return <Spinner {...props} speed="0.75s" />;
};
